import React, { useEffect, useState } from 'react'
import CommonBanner from '../../components/common/CommonBanner'
import Banner from '../../Assets/Service/serviceBanner.png'
import StaffAugmentationSection from '../../components/User/Service/StaffAugmentationSection'
import WorkProcessSection from '../../components/User/Service/WorkProcessSection'
import { useParams } from 'react-router-dom'
import services from "../../config/services.json"

const ServiceDetails = () => {

  const { id } = useParams()
  const [service, setService] = useState(null)

  useEffect(() => {
    const foundService = services.find(serv => serv.id === id)
    setService(foundService)
  }, [id])



  return (
    <div className='overflow-hidden'>
      <CommonBanner backgroundImage={Banner} title="Service Details" subheading="Home/Service Details" />
      <StaffAugmentationSection service={service} />
      <WorkProcessSection service={service} />
    </div>
  )
}

export default ServiceDetails